import { render } from "./Productdetails.vue?vue&type=template&id=18b94913&scoped=true"
import script from "./Productdetails.vue?vue&type=script&lang=js"
export * from "./Productdetails.vue?vue&type=script&lang=js"

import "./Productdetails.vue?vue&type=style&index=0&id=18b94913&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b94913"]])

export default __exports__